// Shared catalog of service categories + Jobboard enums.
// Used by ServiceManagement and the Jobboard UI. functions/jobboard.js keeps its own
// CommonJS copy of the same values — keep the two in sync.

export const SERVICE_TYPES = [
    { value: 'rank_boost', label: 'บูสแรงค์' },
    { value: 'coaching', label: 'สอนเล่น/โค้ช' },
    { value: 'leveling', label: 'อัพเลเวล' },
    { value: 'farming', label: 'ฟาร์ม' },
    { value: 'account_recovery', label: 'กู้คืนบัญชี' },
    { value: 'placement', label: 'Placement Match' },
    { value: 'other', label: 'อื่นๆ' },
];

export const SERVICE_TYPE_LABEL = Object.fromEntries(SERVICE_TYPES.map(t => [t.value, t.label]));

// Jobboard: the poster picks the job type when posting.
//  quote  = "ขอใบเสนอราคา" → existing consultation flow (consulting ฿0 → chat → admin invoice)
//  budget = "จ้างตามงบนี้"  → accepting = agreeing to the budget → straight to payment
export const JOB_TYPES = [
    { value: 'quote', label: 'ขอใบเสนอราคา' },
    { value: 'budget', label: 'จ้างตามงบนี้' },
];

export const HIRE_TYPES = [
    { value: 'fixed', label: 'เหมาจบ' },
    { value: 'per_unit', label: 'ต่อหน่วย (ดาว/เลเวล)' },
    { value: 'hourly', label: 'รายชั่วโมง' },
];

export const PLAY_MODES = [
    { value: 'pilot', label: 'ฝากเล่น (ส่งไอดี)' },
    { value: 'duo', label: 'เล่นด้วยกัน' },
];

export const FIXED_BUDGET_MIN = 50;
export const FIXED_BUDGET_MAX = 50000;
export const QUOTE_BUDGET_MAX = 100000;

// Same check as functions/jobboard.js validFixedBudget — a real integer number, never a string.
export const validFixedBudget = (b) =>
    typeof b === 'number' && Number.isSafeInteger(b) && b >= FIXED_BUDGET_MIN && b <= FIXED_BUDGET_MAX;

// "อื่นๆ" in the game picker: gameId 'other' + the poster's own game name (gameName, gameIsCustom:true).
// "อื่นๆ" in the category picker is serviceType 'other' + customCategory.
export const OTHER_GAME_ID = 'other';
export const CUSTOM_GAME_MAX = 50;
export const CUSTOM_CATEGORY_MAX = 40;

// Title / description: required (non-blank after trim), no minimum length.
export const JOB_TITLE_MAX = 100;
export const JOB_DESC_MAX = 1000;

// Every post waits for an admin / superAdmin review before it goes public.
// A rejection carries a reason; the poster edits and resubmits (status rejected → pending).
export const REJECT_REASON_MAX = 500;
// A rejected post the poster doesn't resubmit within this many days of the review closes
// automatically (server expireJobs, closeReason 'rejected_expired'). Mirrors functions/jobboard.js.
export const JOB_TTL_DAYS = 14;
export const REJECT_REASON_PRESETS = [
    'มีเบอร์โทร / LINE / ช่องทางติดต่อในโพสต์',
    'รายละเอียดไม่ครบ กรุณาระบุเป้าหมาย แรงค์ หรือขอบเขตงานให้ชัดเจน',
    'ไม่ใช่บริการที่ร้านรับ',
    'งบประมาณไม่สอดคล้องกับขอบเขตงาน',
    'เนื้อหาไม่เหมาะสม',
];
